// Referer to below url to include individually components
// http://element.eleme.io/#/en-US/component/quickstart#on-demand

import Vue from 'vue'
import { Form, FormItem, Input, Button, Icon, Popover, Notification } from 'element-ui'

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Popover)

Vue.prototype.$notify = Notification;
